import React from 'react'
import { parseUrlQuery } from "utilities"
import { setSuccessToast, setErrorToast } from '../../../actions'
import { useDispatch } from 'react-redux'
import { VERIFY_EMAIL_ADDRESS } from '../../../requests'
import { Spinner } from 'components/Loaders/Loaders'

const VerifyEmailAddress = ({history, ...props}) => {
  const search = props.location.search
  const { token } = parseUrlQuery(search)
  const dispatch = useDispatch();

  console.log(props, token)

  const verifyEmail = () => {
    VERIFY_EMAIL_ADDRESS(
      {token: token},
      res => {
        console.log(res)
        dispatch(setSuccessToast(`Successfully verified user: ${res.username}`))
        history.push('/auth')
      },
      err => {
        console.log(err)
        dispatch(setErrorToast('Had trouble verifying account. Please try again.'))
      }
    )
  }

  React.useEffect(() => {
    token ?
      verifyEmail()
      :
      history.push('/auth')
  }, [token])

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '50px', fontWeight: 'bold', marginTop: '100px'}}>
      <Spinner size="large" linear themeColor="dark-neutral"/>
      Verifying email account, please wait...
    </div>
  )
}

export default VerifyEmailAddress


// WEBPACK FOOTER //
// ./src/components/Shell/Login/VerifyEmailAddress.js